import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { SesionActivaUsuario } from '../shared/object/sesion-activa-usuario.interface';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class SesionActivaUsuarioService {
  constructor(
    private client: GraphQLClient,
  ) {}

  obtenerTodaSesionesActivas(inputParams: {
    entidad?: SesionActivaUsuario,
    paginaActual?: number,
    cantidadRegistrosPorPagina?: number,
   }, callback: Function) {
    this.client.query({
      query: gql`
        query ($paginaActual: Int!, $cantidadRegistrosPorPagina: Int!) {
          sesion_activa_usuario
          {
            obtenerTodasSesionesActivas(paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina)
            {
              mensajes
              {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  token_refresco
                  rut_usuario
                  fecha_creacion
                  fecha_ultima_actividad
                  fecha_expiracion
                  user_agent
                  ip_address
                  nombreUsuario
                  navegador
                  sistemaOperativo
                  tipoDispositivo
                }
              }
            }
          }
        }
      `,
      variables: inputParams,
      fetchPolicy: 'no-cache'
    }, (response: any) => {
      const notificacion: NotificacionGenerica<SesionActivaUsuario[]> = response.data.sesion_activa_usuario.obtenerTodasSesionesActivas;
      callback(notificacion);
    })
  }

  eliminarSesion(inputParams: {
    entidad: SesionActivaUsuario,
  }, callback: Function) {
    this.client.mutate({
      mutation: gql`
        mutation ($entidad: sesion_activa_usuarioInputType) {
          sesion_activa_usuario
          {
            eliminar(entidad: $entidad)
            {
              mensajes
              {
                codigo
                contexto
                texto
                tipo
              }
            }
          }
        }
      `,
      variables: inputParams,
    }, (response) => {
      const mensajes = response.data.sesion_activa_usuario.eliminar.mensajes;
      callback(mensajes);
    })
  }
}
